const STORAGE_KEY = "affidya_active_struttura_id";

let _activeStrutturaId = null;

function readFromStorage() {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

_activeStrutturaId = readFromStorage();

/** Struttura attiva su questo browser/dispositivo (non sincronizzata tra PC). */
export function getLocalActiveStrutturaId() {
  return _activeStrutturaId;
}

export function setLocalActiveStrutturaId(strutturaId) {
  _activeStrutturaId = strutturaId || null;
  try {
    if (strutturaId) {
      localStorage.setItem(STORAGE_KEY, strutturaId);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Allinea la scelta locale alla lista strutture dell'utente.
 * Restituisce l'id da usare come struttura attiva su questo dispositivo.
 */
export function resolveLocalActiveStrutturaId(userData) {
  const strutture = userData?.strutture || [];
  if (strutture.length === 0) {
    setLocalActiveStrutturaId(null);
    return null;
  }
  if (strutture.length === 1) {
    setLocalActiveStrutturaId(strutture[0].id);
    return strutture[0].id;
  }

  const local = getLocalActiveStrutturaId();
  if (local && strutture.some((s) => s.id === local)) {
    return local;
  }

  const fallback = strutture.find((s) => s.is_primary) || strutture[0];
  setLocalActiveStrutturaId(fallback.id);
  return fallback.id;
}
